// src/components/PreviewDayModal.jsx
import Modal from "react-modal";
import moment from "moment";
import PropTypes from "prop-types";

/* ─────────── Estilos DEL MODAL (idénticos a los que ya usabas) ─────────── */
const modalStyles = {
  overlay: { backgroundColor: "rgba(0,0,0,0.6)", zIndex: 1005 },
  content: {
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "360px",
    maxWidth: "100%",
    borderRadius: "16px",
    padding: 0,
    overflow: "visible",
    boxShadow: "0 4px 16px rgba(0,0,0,0.1)",
    border: "none",
    background: "#fff",
    fontFamily: "'Inter', sans-serif",
  },
};

Modal.setAppElement("#root"); // ↲ sólo una vez en tu app

export default function PreviewDayModal({ isOpen, onClose, event }) {
  if (!isOpen || !event) return null;

  /* ───── icono según tipo ───── */
  const iconMap = {
    cotizacion: "bi-file-earmark-text",
    evento: "bi-calendar-event",
    festivo: "bi-star",
    tarea: "bi-rocket-takeoff",
  };
  const resourceIcon = iconMap[event.resource] || "bi-info-circle";

  return (
    <Modal isOpen={isOpen} onRequestClose={onClose} style={modalStyles}>
      <div
        style={{
          width: "100%",
          position: "relative",
          borderRadius: "16px",
          backgroundColor: "#fff",
          display: "flex",
          flexDirection: "column",
          overflow: "hidden",
        }}
      >
        {/* ─── Esquina diagonal de color ─── */}
        <div
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            width: 40,
            height: 40,
            backgroundColor: event.color || "#374151",
            clipPath: "polygon(0 0, 100% 0, 0 100%)",
            zIndex: 1,
            pointerEvents: "none",
          }}
        />

        {/* ─── Botón cerrar ─── */}
        <button
          onClick={onClose}
          title="Cerrar"
          style={{
            position: "absolute",
            top: 5,
            right: 0,
            backgroundColor: "#F3F4F6",
            border: "none",
            borderRadius: "50%",
            width: 25,
            height: 25,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            cursor: "pointer",
          }}
        >
          <i
            className="bi bi-x-lg"
            style={{ fontSize: "12px", color: "#374151" }}
          />
        </button>

        {/* ─── Cabecera (mini-calendario + título + hora) ─── */}
        <div
          style={{
            display: "flex",
            alignItems: "flex-start",
            gap: 12,
            marginTop: 35,
            marginBottom: 8,
            padding: "0 16px",
            position: "relative",
            zIndex: 2,
          }}
        >
          {/* Mini-calendario */}
          <div style={{ flexShrink: 0, width: 62, lineHeight: 1 }}>
            <div
              style={{
                background: "#fff",
                borderRadius: 8,
                boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
                paddingBottom: 8,
                textAlign: "center",
              }}
            >
              <div
                style={{
                  width: "100%",
                  background: "#374151",
                  color: "#fff",
                  fontSize: "9px",
                  fontWeight: 700,
                  textTransform: "uppercase",
                  padding: "10px 0 6px",
                  borderTopLeftRadius: 8,
                  borderTopRightRadius: 8,
                  marginBottom: 4,
                }}
              >
                {moment(event.start).format("MMMM")}
              </div>
              <div
                style={{
                  fontSize: "1.6rem",
                  fontWeight: 700,
                  color: "#111827",
                }}
              >
                {moment(event.start).format("D")}
              </div>
            </div>
          </div>

          {/* Título + hora */}
          <div style={{ flexGrow: 1 }}>
            <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
              <i
                className={`bi ${resourceIcon} text-2xl`}
                style={{ color: "#374151" }}
              />
              <h3
                style={{
                  margin: 0,
                  fontSize: "1.15rem",
                  fontWeight: 700,
                  color: "#111827",
                }}
              >
                {event.title}
              </h3>
            </div>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: 6,
                fontSize: "0.95rem",
                color: "#6B7280",
                marginTop: 6,
              }}
            >
              <i className="bi bi-bell-fill" />
              {moment(event.start).format("HH:mm")}
            </div>
          </div>
        </div>

        {/* ─── Nota ─── */}
        <div
          style={{ padding: "0 16px", marginBottom: 16, height: 85, zIndex: 2 }}
        >
          <div
            style={{
              fontSize: "0.95rem",
              fontWeight: 600,
              color: "#374151",
              marginBottom: 4,
            }}
          >
            Notas
          </div>
          <div
            style={{
              fontSize: "0.9rem",
              color: "#4B5563",
              lineHeight: 1.4,
              whiteSpace: "pre-wrap",
            }}
          >
            {event.note && event.note.trim() !== ""
              ? event.note
              : "— sin descripción —"}
          </div>
        </div>

        {/* ─── Pie con fechas ─── */}
        <div
          style={{
            backgroundColor: "#F8FAFB",
            padding: "20px 16px",
          }}
        >
          <div
            style={{
              fontSize: "0.95rem",
              fontWeight: 600,
              color: "#374151",
              marginBottom: 4,
            }}
          >
            Fecha
          </div>
          <div style={{ fontSize: "0.9rem", color: "#4B5563" }}>
            {moment(event.start).format("LL")} —{" "}
            {moment(event.end).format("LL")}
          </div>
        </div>
      </div>
    </Modal>
  );
}

PreviewDayModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  event: PropTypes.object, // null cuando está cerrado
};
